import { createApp } from "vue";
import { createTranslationsPlugin, setShowSignInDialog, getUser } from "@ado/base-application";
import "@ado/base-application/style.css"
import Banner from "./banner.vue";
import { AcsStandardLibraryBundledPlugin } from "@ado/acs-standard-library";

let conf = { footerEnabled: false };
if (window.bannerStyle) {
	conf.bannerStyle = window.bannerStyle;
}

const app = createApp(Banner, conf);

const i18n = createTranslationsPlugin();
app.use(i18n);

const acsPlugin = new AcsStandardLibraryBundledPlugin();
app.use(acsPlugin);

app.mount(`#banner`);

//This exposes a methods that will allow use the Base Application methods from outside the base application
//Once all is migrated to Vite this should no longer be necessary
window.bannerSignIn = function () {
	setShowSignInDialog(true);
}
window.bannerIsLoggedIn = function () {
	return getUser().isSignedIn;
}
